import React, { useRef } from "react";
import { Button, ButtonGroup, Flex, Stack, Text } from "@chakra-ui/react";
import Orange from "./Orange";
import { Link } from "react-router-dom";
import { HashLink } from "react-router-hash-link";


export default function Home() {
  return (
    <div id="top">
      <Flex h="100vh" justifyContent={"center"}>
        <Flex
          top="10%"
          alignItems={"center"}
          justifyContent={"center"}
          flexDir={"column"}
        >
          <Text
            variant={"bigHeader"}
            color="lightblue"
            px={{ lg: "0rem", base: "2rem" }}
          >
            Hi, I'm Jessica!
          </Text>
          <Text
            variant={"typeItalic"}
            px={{ lg: "0rem", base: "2rem" }}
            mt="1rem"
            textAlign="center"
          >
            programmer. designer. artist. <br></br>
            currently @ dassault systemes <br></br>
            prev @ brown
          </Text>

          <Stack direction="column" spacing={4} align="center" mt="4rem">
            <HashLink smooth to="/#resume">
              <Button
                variant="outline"
                px="3rem"
                color="lightblue"
                borderColor="lightblue"
                _hover={{ borderColor: "black", color: "black" }}
              >
                Resume
              </Button>
            </HashLink>
            <HashLink smooth to="/#work">
              <Button
                variant="solid"
                px="3rem"
                color="offwhite"
                bg="lightblue"
                _hover={{ bg: "black" }}
              >
                My Work
              </Button>
            </HashLink>
          </Stack>
        </Flex>
      </Flex>
    </div>
  );
}
